import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'

import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import CustomCheckBox from 'component/utils/CustomCheckBox'

class Filter extends Component {
  constructor(props) {
    super(props)

    this.state = {
      menus: [],
      error: null,
      loading: false,
      type: {
        typeall: 0,
        typetext: 0,
        typevideo: 0,
      },
      func: {
        menuAll: 0,
      },
    }
  }

  componentDidMount() {
    const { user } = this.props

    this.setState({ loading: true })

    /* istanbul ignore else */
    if (user) {
      return new Api(user.dsToken)
        .get(API_URL.FETCH_HELP_FUNC)
        .then((response) => this.onFetchSuccess(response.data))
        .catch((error) => this.onFetchError(error))
    }
  }

  onFetchSuccess = (menus) => {
    const func = {
      menuAll: 0,
      ...menus.reduce((a, e) => {
        a[e.key] = 0
        return a
      }, {}),
    }

    this.setState({ menus, loading: false, error: null, func })
  }

  onFetchError = (error) => {
    this.setState({ error, loading: false, menus: [] })
  }

  renderFunc = (menu) => (
    <Col xs={12} md={12}>
      <div className='field'>
        <CustomCheckBox
          id={menu.key}
          label={menu.value}
          currentValue={this.state.func[menu.key]}
          onChange={this.handleFuncChange}
        />
      </div>
    </Col>
  )

  handleFuncChange = (event) => {
    const { menus } = this.state
    const { name, checked } = event.target
    let value = 0
    if (checked) {
      value = 1
    }
    if (name === 'menuAll') {
      const func = {
        menuAll: value,
        ...menus.reduce((a, e) => {
          a[e.key] = value
          return a
        }, {}),
      }
      this.setState({ func })
    } else {
      this.setState({
        func: {
          ...this.state.func,
          [name]: value,
          menuAll: -1,
        },
      })
    }
  }

  handleTypeChange = (event) => {
    const { name, checked } = event.target
    let value = 0
    if (checked) {
      value = 1
    }

    if (name === 'typeall') {
      this.setState({
        type: {
          typeall: value,
          typetext: value,
          typevideo: value,
        },
      })
    } else {
      this.setState({
        type: {
          ...this.state.type,
          [name]: value,
          typeall: -1,
        },
      })
    }
  }

  checkDisabled = () => {
    const { type, func } = this.state
    if (Object.values(type).some((e) => e === 1)) {
      return
    }
    if (Object.values(func).some((e) => e === 1)) {
      return
    }
    return 'disabled'
  }

  render() {
    const { visible, translate, onSubmit } = this.props
    const { loading, menus, type, func } = this.state
    return (
      <div
        className='filter-adjustment side-filter margin-top-negative'
        style={{ display: visible ? 'block' : 'none' }}
      >
        <div>
          <h4> {translate('label.help.config.functionalities')}</h4>
        </div>

        {!loading && (
          <Row>
            <Col xs={12} md={12}>
              <div className='field'>
                <CustomCheckBox
                  id={`menuAll`}
                  onChange={this.handleFuncChange}
                  currentValue={func.menuAll}
                  label={translate('option.all')}
                />
              </div>
            </Col>
            {menus.map(this.renderFunc)}
          </Row>
        )}

        <div>
          <h4> {translate('label.help.config.type.help')}</h4>
        </div>

        <Row>
          <Col xs={12} md={12}>
            <div className='field'>
              <CustomCheckBox
                id={`typeall`}
                label={translate('option.all')}
                currentValue={type.typeall}
                onChange={this.handleTypeChange}
              />
            </div>
          </Col>

          <Col xs={12} md={12}>
            <div className='field'>
              <CustomCheckBox
                id={`typetext`}
                label={translate('option.text')}
                currentValue={type.typetext}
                onChange={this.handleTypeChange}
              />
            </div>
          </Col>
          <Col xs={12} md={12}>
            <div className='field'>
              <CustomCheckBox
                id={`typevideo`}
                currentValue={type.typevideo}
                onChange={this.handleTypeChange}
                label={translate('Video')}
              />
            </div>
          </Col>
        </Row>

        <Row className={`padding-top padding-bottom`}>
          <button
            className={`button button-primary button-full ${this.checkDisabled()}`}
            onClick={onSubmit}
          >
            {translate('buttom.help.config.filter')}
          </button>
        </Row>
      </div>
    )
  }
}

Filter.propTypes = {
  translate: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  user: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
}

export default Filter
